import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IconNames, NOT_AVAILABLE, S_CODE_ICONS, SCode } from '../../common/constants';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-status-code',
  imports: [CommonModule, IntrackFeatureModule, TranslateModule, SvgIconComponent],
  templateUrl: './status-code.component.html',
  styleUrls: ['./status-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusCodeComponent {
  @Input() statusCode: string;
  @Input() statusDescription: string;
  @Input() needEmptySpaceFoNoIconCase = true;

  sCodeIcons: Map<SCode, IconNames> = S_CODE_ICONS;
  notAvailable = NOT_AVAILABLE;
}
